<template>
  <div class="mb-5" v-if="loaded">
    <h3 class="mb-5">Le prossime date di consegna:</h3>
    <div v-for="date in nextAvailableDates">
      <div class="flex-vcenter mt-2">
        <i class="fas fa-circle pr-3" style="color: #9ec939"></i>
        <span class="capitalize">
          {{ date.delivery.format("dddd DD MMMM") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { recurring } from "../../mixins/recurring"

export default {
  props: {
    value: {
      type: Object
    },
    shipmentZone: {
      type: Object
    }
  },
  data() {
    return {
      loaded: false
    }
  },
  mixins: [
    recurring
  ],
  computed: {
    nextAvailableDates() {
      return this.getSkippableRange.filter(el => !el.skipped && el.active).slice(0, 2)
    }
  },
  mounted() {
    this.loaded = false;
    this.loadSkippable().then(i => {
      this.loaded = true
    })
  }
};
</script>
